import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./Styles/style.css"
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './Context/context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppProvider>
    <App />
  </AppProvider>
);
reportWebVitals();
